import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 工單需求彙總轉倉 detail；形狀沿用 Stock Transfer。 */
export async function fetchWorkOrderStockTransferDetail(id) {
  const { data: raw } = await request.get(
    `/mom/work-order/stock-transfer/${id}`,
  );
  return parseVer4DetailResponse(raw);
}
